/* HerNext landing — ticker, smooth anchors, sticky CTA bar, AJAX add-to-cart that opens the theme cart drawer */
(function () {
  if (window.__hernext) return;
  window.__hernext = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Heart-rate number + timer ---------- */
  var seq = [118, 120, 121, 123, 124, 124, 126, 125, 123, 122, 121, 119];
  var t = 0;
  function tick() {
    var secs = 734 + t, mm = Math.floor(secs / 60), ss = secs % 60;
    document.querySelectorAll('[data-hn-bpm]').forEach(function (el) {
      var base = parseInt(el.getAttribute('data-hn-bpm'), 10) || 124;
      el.textContent = base + (seq[t % seq.length] - 124);
    });
    document.querySelectorAll('[data-hn-timer]').forEach(function (el) {
      el.textContent = mm + ':' + (ss < 10 ? '0' : '') + ss;
    });
    t++;
  }
  function startTicker() { tick(); if (!reduce) setInterval(tick, 1000); }

  /* ---------- Smooth scrolling for #hn-… links ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#hn-"]');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });

  /* ---------- Sticky CTA bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-hn-sticky]');
    if (!bar) return;
    var pricing = document.getElementById('hn-pricing');
    var showAfter = parseInt(bar.getAttribute('data-hn-sticky'), 10) || 700;
    var pricingVisible = false;
    if (pricing && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        pricingVisible = entries[0].isIntersecting; update();
      }, { threshold: 0.15 }).observe(pricing);
    }
    function update() {
      var on = window.scrollY > showAfter && !pricingVisible;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- AJAX add to cart ---------- */
  // Horizon (2025+) refreshes the cart drawer through Shopify's standard events module
  // ("@shopify/events" in the theme import map): a CartLinesUpdateEvent whose promise
  // resolves with { cart, detail: { sections } }. On top of that we verify the drawer
  // really shows the new line and, if not, re-render it ourselves (Section Rendering API)
  // before opening it, so the customer never needs a page refresh.
  var eventsPromise = null;
  function loadEvents() {
    if (!eventsPromise) {
      eventsPromise = new Promise(function (resolve) {
        var done = false, finish = function (m) { if (!done) { done = true; resolve(m || null); } };
        setTimeout(function () { finish(null); }, 2500);
        try { import('@shopify/events').then(finish, function () { finish(null); }); } catch (e) { finish(null); }
      });
    }
    return eventsPromise;
  }
  loadEvents();

  function cartItemsEls() { return [].slice.call(document.querySelectorAll('cart-items-component[data-section-id]')); }

  function cartSectionIds() {
    var ids = [];
    cartItemsEls().forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer', 'cart-icon-bubble'); // Dawn-family themes
    return ids;
  }

  // Horizon's drawer: <theme-drawer id="cart-drawer"> > dialog > cart-drawer-component >
  // .cart-drawer__inner[data-hydration-key] which holds BOTH the header (title + count badge)
  // and <cart-items-component>. Going from an empty to a filled cart the whole inner block
  // changes (the "cart-drawer--empty" class, the header, the summary), so it has to be
  // refreshed as one unit, the same way Horizon's own morph does it.
  var DRAWER_SECTION = 'cart-drawer-section';
  function drawerInner() { return document.querySelector('#cart-drawer .cart-drawer__inner'); }

  // Does the drawer already show this cart (header, empty-state and every line)?
  function drawerInSync(cart) {
    var inner = drawerInner();
    var scope = inner || (cartItemsEls()[0] || null);
    if (!scope) return true; // nothing we can check
    if (cart.item_count > 0) {
      if (inner && inner.classList.contains('cart-drawer--empty')) return false;
      if (scope.querySelector('[data-cart-drawer-empty]')) return false;
      var badge = inner && inner.querySelector('.theme-drawer__badge');
      if (inner && (!badge || badge.textContent.trim() !== String(cart.item_count))) return false;
    }
    for (var i = 0; i < cart.items.length; i++) {
      if (!scope.querySelector('[data-key="' + cart.items[i].key + '"]')) return false;
    }
    return true;
  }

  function injectSectionStyles(doc, host) {
    var st = doc.querySelector('style[data-section-stylesheet]');
    if (!st || !host) return;
    var cur = host.querySelector('style[data-section-stylesheet]');
    if (cur) cur.textContent = st.textContent; else host.prepend(st.cloneNode(true));
  }

  // Swap the whole drawer inner block with freshly rendered markup.
  function replaceDrawer(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = drawerInner();
    var fresh = doc.querySelector('.cart-drawer__inner');
    if (inner && fresh) {
      inner.className = fresh.className;
      inner.replaceChildren.apply(inner, [].slice.call(fresh.childNodes).map(function (n) { return document.importNode(n, true); }));
      injectSectionStyles(doc, document.getElementById('shopify-section-' + DRAWER_SECTION));
      return true;
    }
    // Non-Horizon markup: swap each cart-items-component
    var changed = false;
    cartItemsEls().forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      var f = doc.querySelector('cart-items-component[data-section-id="' + id + '"]') || doc.querySelector('cart-items-component');
      if (f) { el.replaceWith(document.importNode(f, true)); changed = true; }
    });
    return changed;
  }

  function fetchSections(ids) {
    var url = root + '?sections=' + encodeURIComponent(ids.join(','));
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function updateCount(cart) {
    var n = cart.item_count;
    document.querySelectorAll('.header-actions__cart-icon').forEach(function (node) {
      node.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    });
    document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (node) {
      node.textContent = n;
    });
    document.querySelectorAll('.cart-bubble').forEach(function (node) { node.classList.toggle('visually-hidden', n === 0); });
  }

  function waitForSync(cart, ms) {
    var t0 = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        if (drawerInSync(cart)) return resolve(true);
        if (Date.now() - t0 > ms) return resolve(false);
        setTimeout(check, 100);
      })();
    });
  }

  // Prefer Horizon's own morph (keeps its components/animations); fall back to a plain swap.
  function applyDrawerHtml(html) {
    var p;
    try { p = import('@theme/section-renderer'); } catch (e) { p = Promise.reject(e); }
    return p.then(function (m) {
      if (!m || typeof m.morphSection !== 'function') throw new Error('no morph');
      return Promise.resolve(m.morphSection(DRAWER_SECTION, html, { mode: 'hydration', injectStylesheet: true }));
    }).catch(function () { return replaceDrawer(html); });
  }

  // Make sure the drawer shows the cart, then open it.
  function syncDrawer(cart, added, horizon) {
    var hasHorizonDrawer = !!drawerInner();
    return waitForSync(cart, horizon ? 900 : 0).then(function (ok) {
      if (ok) return true;
      var html = added && added.sections && added.sections[DRAWER_SECTION];
      var get = html ? Promise.resolve(html) : (hasHorizonDrawer
        ? fetchSections([DRAWER_SECTION]).then(function (m) { return m && m[DRAWER_SECTION]; })
        : fetchSections(cartItemsEls().map(function (el) { return el.getAttribute('data-section-id'); })).then(function (m) { replaceDrawerMap(m); return null; }));
      return get.then(function (h) {
        if (!h) return;
        return applyDrawerHtml(h).then(function () {
          if (drawerInSync(cart)) return;
          replaceDrawer(h); // morph left it stale: hard swap
        });
      });
    }).catch(function () {}).then(function () { updateCount(cart); });
  }
  function replaceDrawerMap(map) {
    if (!map) return;
    Object.keys(map).forEach(function (k) { replaceDrawer(map[k]); });
  }

  function openDrawer(addResponse) {
    var td = document.getElementById('cart-drawer');
    // Horizon: <theme-drawer id="cart-drawer">
    if (td && typeof td.open === 'function' && td.tagName !== 'CART-DRAWER') {
      if (!td.isOpen) td.open();
      return true;
    }
    // Older Horizon builds
    var hz = document.querySelector('cart-drawer-component');
    if (hz) {
      if (typeof hz.open === 'function') { hz.open(); return true; }
      if (typeof hz.showDialog === 'function') { hz.showDialog(); return true; }
      var dlg = hz.closest('dialog') || hz.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); return true; }
    }
    // Dawn family
    var dawn = document.querySelector('cart-drawer');
    if (dawn && typeof dawn.renderContents === 'function' && addResponse && addResponse.sections) {
      dawn.classList.remove('is-empty');
      dawn.renderContents(addResponse);
      return true;
    }
    return false;
  }

  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-hn-atc]');
    if (!form) return;
    var mode = form.getAttribute('data-hn-atc');
    if (mode === 'checkout') return; // normal POST to /cart/add with return_to=/checkout
    e.preventDefault();
    if (form.__hnBusy) return;
    form.__hnBusy = true;

    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-hn-atc-error]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (err) err.hidden = true;

    var fd = new FormData(form);
    var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
    form.querySelectorAll('input[name="hn_extra_id"]').forEach(function (inp) {
      if (inp.value) items.push({ id: Number(inp.value), quantity: 1 });
    });
    var body = { items: items };
    var sections = cartSectionIds();
    if (sections.length) body.sections = sections.join(',');

    var lib = null, deferred = null;
    (mode === 'drawer' ? loadEvents() : Promise.resolve(null))
      .then(function (m) {
        lib = m;
        // Tell Horizon an add is starting (it waits on the promise to re-render the drawer).
        if (lib && lib.CartLinesUpdateEvent) {
          try {
            deferred = lib.CartLinesUpdateEvent.createPromise();
            form.dispatchEvent(new lib.CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
              promise: deferred.promise
            }));
          } catch (x) { deferred = null; }
        }
        return getJSON(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
      })
      .then(function (added) {
        if (mode === 'cart') { window.location.href = root + 'cart'; return; }
        if (mode === 'silent') {
          return getJSON(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
            return syncDrawer(cart, added, false).then(function () {
              if (btn) {
                btn.classList.add('is-added');
                var lab = btn.querySelector('[data-hn-label]');
                if (lab && btn.getAttribute('data-added')) lab.textContent = btn.getAttribute('data-added');
              }
              document.dispatchEvent(new CustomEvent('hernext:cart-added', { detail: { cart: cart, added: added, silent: true } }));
            });
          });
        }
        return getJSON(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
          var detail = {
            items: cart.items, source: 'hernext-landing', sourceId: form.id,
            itemCount: items[0].quantity, productId: form.getAttribute('data-product-id'),
            sections: added.sections || {}, didError: false
          };
          // 1) put the fresh drawer markup in place first (no flash of the old, empty drawer),
          // 2) then let Horizon finish its own bookkeeping (count bubble, auto-open, a11y),
          // 3) then open the drawer.
          return syncDrawer(cart, added, false).then(function () {
            if (deferred) {
              deferred.resolve({ cart: lib.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: detail });
            } else {
              var ev = new Event('cart:update', { bubbles: true }); // legacy Horizon event
              ev.detail = { resource: cart, sourceId: form.id, data: detail };
              form.dispatchEvent(ev);
            }
            document.dispatchEvent(new CustomEvent('hernext:cart-added', { detail: { cart: cart, added: added } }));
            return new Promise(function (r) { requestAnimationFrame(function () { r(); }); });
          }).then(function () {
            if (!openDrawer(added)) window.location.href = root + 'cart';
          });
        });
      })
      .catch(function (error) {
        if (deferred) {
          getJSON(root + 'cart.js').then(function (cart) {
            deferred.resolve({ cart: lib.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'hernext-landing' } });
          }).catch(function () { deferred.reject(error); });
        }
        if (err) { err.textContent = (error && (error.description || error.message)) || 'Something went wrong. Please try again.'; err.hidden = false; }
      })
      .then(function () { form.__hnBusy = false; if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { startTicker(); initSticky(); });
  } else { startTicker(); initSticky(); }
})();
